import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none" viewBox="0 0 16 14">
      <path
        fill="white"
        d="M1.07301e-06 4.662C-0.000420665 4.04927 0.123482 3.44248 0.364614 2.87637C0.605747 2.31026 0.959372 1.79596 1.40524 1.36291C1.85111 0.92986 2.38046 0.586572 2.96299 0.352705C3.54551 0.118837 4.16976 -0.00101657 4.8 6.49463e-06H11.2C13.8504 6.49463e-06 16 2.09612 16 4.662V14H4.8C2.1496 14 1.07301e-06 11.9039 1.07301e-06 9.338V4.662ZM14.4 12.4444V4.662C14.3979 3.83795 14.0599 3.0483 13.4601 2.46604C12.8603 1.88378 12.0476 1.55638 11.2 1.55556H4.8C4.37988 1.55454 3.96368 1.63416 3.57528 1.78985C3.18687 1.94554 2.8339 2.17425 2.53661 2.46285C2.23931 2.75145 2.00354 3.09427 1.84282 3.47166C1.6821 3.84904 1.59958 4.25355 1.6 4.662V9.338C1.60212 10.1621 1.94009 10.9517 2.53989 11.534C3.13968 12.1162 3.9524 12.4436 4.8 12.4444H14.4ZM9.6 6.22223H11.2V7.77778H9.6V6.22223ZM4.8 6.22223H6.4V7.77778H4.8V6.22223Z"
      ></path>
    </svg>
  )
}

export default Icon
